import React from 'react';

const Mapa = () => {
  return (
    <div className="map-container">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3623.7375135349043!2d-65.4002381!3d-24.7358902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941bc165742730e3%3A0xe28bac6a057f81d6!2sConsultora%20Ciberseguridad!5e0!3m2!1ses-419!2sar!4v1752680304684!5m2!1ses-419!2sar"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Mapa;

